<template>
  <div class="info" v-if="params != null">
    <div class="main">
      <van-cell-group>
        <van-cell
          required
          title="网吧地区"
          :value="
            params.provinceName + ' ' + params.cityName + ' ' + params.areaName
          "
        />
      </van-cell-group>
      <van-cell-group>
        <van-cell required title="详细地址" :value="params.siteAddress" />
      </van-cell-group>
      <van-cell-group>
        <van-cell required title="联系电话" :value="params.principalTel" />
      </van-cell-group>
      <div style="margin:10px 0">
        <van-cell-group>
          <van-field
            v-model="user_phone"
            required
            label="本人联系电话"
            input-align="right"
            placeholder="请输入"
          />
        </van-cell-group>
      </div>
      <van-cell-group>
        <van-cell
          title="地区"
          is-link
          :value="
            area_name.length == 0
              ? '请选择'
              : area_name[0].name +
                ' ' +
                area_name[1].name +
                ' ' +
                area_name[2].name
          "
          @click="showPicker = true"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          label="详细地址"
          input-align="right"
          placeholder="请输入"
          v-model="address"
        />
      </van-cell-group>
    </div>
    <div class="tips">
      本次活动仅面向网吧工作人员，奖品邮寄地址默认为网吧地址，不可修改，若网吧地址有变更，请在下方发起地址变更申请，后台审核通过后，便于派发奖品。
    </div>
    <button @click="save">提交</button>
    <van-popup v-model="showPicker" round position="bottom">
      <van-area
        title="标题"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :area-list="areaList"
        value="110101"
      />
    </van-popup>
  </div>
  <van-skeleton title avatar :row="20" v-else />
</template>

<script>
import { getNetbarId, submitWinner } from "@/api/draw.js";
import { areaList } from "@vant/area-data";
import { Toast } from "vant";
export default {
  data() {
    return {
      showPicker: false,
      areaList,
      area_name: [],
      params: null,
      address: "",
      user_phone: "",
    };
  },
  created() {
    this.getParams();
  },
  methods: {
    async getParams() {
      const netBarId = this.$cookies.get("internetBarId");
      const data = await getNetbarId({ netBarId });
      console.log(data);
      if (data.code == 200) {
        this.params = data.data;
      }
    },
    onConfirm(value) {
      console.log(value);
      this.area_name = value;
      this.showPicker = false;
    },
    save() {
      const internetBarId = this.$cookies.get("internetBarId");
      const userId = JSON.parse(window.sessionStorage.getItem("loginInfo")).id;
      const query = this.$route.query;
      if (this.user_phone.length == 0) {
        Toast("请输入手机号");
      } else {
        /**
         * provinceCode: this.area_name[0].code,
          provinceName: this.area_name[0].name,
          cityCode: this.area_name[1].code,
          cityName: this.area_name[1].name,
          areaCode: this.area_name[2].code,
          areaName: this.area_name[2].name,
         */

        let params = {
          internetBarId,
          userId,
          activityId: query.activity_id,
          activityPrizeName: query.activityPrizeName,
          activityPrizeId: query.activity_prize_id,
          userPhone: this.user_phone,
		  id:query.winnerId,
        };
        if (this.area_name.length > 0) {
          let res = {
            provinceCode: this.area_name[0].code,
            provinceName: this.area_name[0].name,
            cityCode: this.area_name[1].code,
            cityName: this.area_name[1].name,
            areaCode: this.area_name[2].code,
            areaName: this.area_name[2].name,
            address: this.address,
          };
          params = Object.assign({}, params, res);
        }
        console.log(params);
        this.onSave(params);
      }
    },
    async onSave(params) {
      const data = await submitWinner(params);
      console.log(data);
      if (data.code == 200) {
        let that = this;
        Toast({
          type: "success",
          overlay: true,
          message: "提交成功",
          forbidClick: true,
          duration: 1500,
          onClose: function() {
            that.$router.go(-1);
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.info {
  background-color: #f6f6f6;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  .tips {
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    padding: 15px;
  }
  button {
    margin-top: 30px;
    border: none;
    width: 349px;
    height: 44px;
    background: linear-gradient(90deg, #05aefc 0%, #008cff 100%);
    border-radius: 22px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
